import React, { useEffect, useState } from 'react';
import { getSettings } from './apiUtils'; // Assuming you placed the utility function in a separate file
import { getBaseUrl } from "../utils";
import Navbar from "./Navbar";
import Footer from "./Footer";

const TermsAndConditions = () => {
  const [termsOfService, setTermsOfService] = useState('');
  const baseUrl = getBaseUrl(); // Replace with your actual base URL
  const token = localStorage.getItem('userToken'); // Assuming the token is saved in local storage

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchSettings = async () => {
      const data = await getSettings(baseUrl, token);
      if (data) {
        setTermsOfService(data.terms_of_service); // Setting the fetched terms of service content
      }
    };
    fetchSettings();
  }, [baseUrl, token]);

  return (
    <div className="bg-gray-100 min-h-screen">
      <Navbar />
      <div className="terms-conditions-container py-8 px-6 sm:px-10 mx-6 sm:mx-12">
        <h2 className="text-2xl font-bold mb-6 text-center text-blue-600">Terms & Conditions</h2>
          <div
            className="terms-conditions-content"
            dangerouslySetInnerHTML={{ __html: termsOfService }}
          />
      </div>
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
